import { createHttpClient } from '@adapters/HttpClient';
import { ProfitabilityApiAdapter } from '../adapters/ProfitabilityApiAdapter';
import type { ProfitabilityCommonFilters, ProfitabilitySummaryResponse } from '../models/Profitability';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';

const httpClient = createHttpClient(apiClientWH);
const adapter = new ProfitabilityApiAdapter(httpClient);

export const useProfitabilitySummary = (filters: ProfitabilityCommonFilters | undefined, enabled = true) => {
  return useQuery<ProfitabilitySummaryResponse, Error>({
    queryKey: ['profitability', 'summary', filters],
    queryFn: () => adapter.getSummary(filters),
    enabled,
    staleTime: 60 * 1000,
  });
};
